import BaseModel from './BaseModel';

class WorkOrder extends BaseModel {
  constructor(data = {}){
    super(data);
    this.setApiDetailsData(data);
  }

  setApiDetailsData = (data) => {
    this.work_order_details = {
      id: data.nomenclature,
      category: `${data.category?.id} - ${data.category?.name}`,
      parent_category: `${data.parent_category?.id} - ${data.parent_category?.name}`,
      ticket: `${data.ticket?.id} - ${data.ticket?.name}`,
      details: data.details || "-",
      status: data.status,
      created_at: data.created_at,
      resolution_codes: (data.resolution_codes && data.resolution_codes.length !== 0) ? data.resolution_codes : '-',
    };
    this.handler_details = data.technician || {};
    this.raised_for = data.raised_for || {};
    this.version_details = data.versions || [];
    this.service_center_details = {
      id: data.service_center?.sc_nomenclature,
      name: data.service_center?.name
    };
    this.transfer_orders = data.transfer_orders || [];
  }
}

export default WorkOrder;
